// extracted by mini-css-extract-plugin
export default {"frameContainer":"styles_frameContainer__nvzEU","innerSquare":"styles_innerSquare__ue0b1","downArrow":"styles_downArrow__VkC1X","upArrow":"styles_upArrow__ZxFsF"};